import { Query } from "custom-types/Query";

export default ({
  q,
  shopCategory,
  shopName,
  product_category,
  strain_category,
  strain_name,
  type,
  deal_active,
}: Query) => {
  const query: Query = { q };

  if (shopCategory && shopName) {
    query[`filter[${shopCategory}_name]`] =
      typeof shopName === "string" ? [shopName] : shopName;
  }

  if (product_category) {
    query["filter[product_category]"] = String(product_category);
  }

  if (strain_category) {
    query["filter[strain_category]"] = String(strain_category);
  }

  if (strain_name) {
    query["filter[strain_name]"] = String(strain_name);
  }

  if (type) {
    query["filter[type]"] = String(type);
  }

  if (deal_active) {
    query["filter[deal_active]"] = "true";
  }

  return query;
};
